<template>
  <t-dialog ref="dialog" @close="removeActive">
    <template v-slot:text>

      <template v-if="!detail">
        <t-spinner />
      </template>

      <template v-else>
        <div class="course-detail-dialog">
          <img class='course-detail-cover' v-if="!!detail.imagem" :src="detail.imagem" alt="Capa do E-book" />
          <div class='course-detail-description' v-if="!!detail.descricao">
            <h3>Conteúdo</h3>
            <span v-html="detail.descricao" />
          </div>
          <div class='course-detail-objective' v-if="!!detail.objetivo">
            <h3>Objetivos Gerais:</h3>
            <span v-html="detail.objetivo" />
          </div>
          <div class='course-detail-general' v-if="!!detail.objetivoGeral">
            <h3>Objetivos Específicos:</h3>
            <span v-html="detail.objetivoGeral" />
          </div>
        </div>
      </template>

    </template>
  </t-dialog>
</template>

<script>
import TSpinner from '@/components/base/TSpinner'
import TDialog from '@/components/base/TDialog'

let timeout = null

export default {
  name: 't-detail',
  props: ['loading', 'detail', 'error'],
  components: { TSpinner, TDialog },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    styles () {
      return {
        detail: {
          color: this.$forSize['phone-only'] ? this.$config.colors.on.surface : this.$config.colors.on.surface
        }
      }
    }
  },
  mounted () {
    const elementIsFullyVisible = element => {
      const rect = element.getBoundingClientRect()
      return (rect.x > -rect.width) && (rect.x < window.innerWidth)
    }
    const getActiveTarget = () => {
      const currentTarget = document.getElementsByClassName('active')[0]
      if (currentTarget) {
        if (!elementIsFullyVisible(currentTarget)) {
          currentTarget.classList.remove('active')
          this.visible = false
        }
      }
      return currentTarget
    }
    const updateArrowPosition = () => {
      if (this.visible) {
        const target = getActiveTarget()
        if (target && this.$refs.arrow) {
          const tRect = target.getBoundingClientRect()
          const arrow = this.$refs.arrow
          const aRect = arrow.getBoundingClientRect()
          const container = this.$refs.container
          const cRect = container.getBoundingClientRect()
          const arrowMarginLeft = Math.min(Math.max(tRect.x + tRect.width / 2 - aRect.width / 2, cRect.x), cRect.x + cRect.width - aRect.width)
          arrow.style.marginLeft = `${arrowMarginLeft}px`
        } else {
          this.visible = false
        }
      }
      window.requestAnimationFrame(updateArrowPosition)
    }
    window.requestAnimationFrame(updateArrowPosition)
  },
  methods: {
    show (activeCard) {
      this.visible = false
      clearTimeout(timeout)
      this.visible = false
      this.$refs.dialog.open()
    },
    close () {
      this.visible = false
      this.removeActive()
    },
    removeActive () {
      Array.from(document.getElementsByClassName('active')).forEach(el => {
        el.classList.remove('active')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.course-detail-dialog {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  > div {
    width: 100%;
    padding-bottom: 15px;
    color: var(--on-surface);

    > h3 {
      padding-bottom: 5px;
      font-size: 16px;

      @include for-size(desktop-up) {
        font-size: 20px;
      }

      @include for-size(big-desktop-up) {
        font-size: 26px;
      }
    }

    &:last-child {
      padding-bottom: none;
    }

    @include for-size(desktop-up) {
      width: 75%;
    }
  }

  .course-detail-cover {
    display: block;
    margin: 0 auto;
  }

  .course-detail-description, .course-detail-objective, .course-detail-general {
    > span, > span > * {
      font-size: 14px;

      @include for-size(desktop-up) {
        font-size: 16px;
      }

      @include for-size(big-desktop-up) {
        font-size: 20px;
      }
    }
  }
}
</style>
